import React from 'react';
import compact from 'lodash/compact';
import isEmpty from 'lodash/isEmpty';
import { useTheme } from '@mui/material/styles';
import { useViewports } from '../../../hooks/useViewports';
import { SubMenuSection } from '../SubMenuSection';
import { MENU_LAYOUT } from '../types';
import * as S from './styles';
const SubMenuContainer = ({ id, subMenus, clickCallback }) => {
    const theme = useTheme();
    const { isMobile } = useViewports(theme);
    if (typeof subMenus === 'undefined') {
        return null;
    }
    const { top, main, sidebar, bottom, layout = MENU_LAYOUT.Default } = subMenus;
    const handleMenuKeyDown = (e) => {
        var _a, _b, _c, _d;
        const nodeList = e.currentTarget.querySelectorAll('[role="menuitem"]');
        const items = Array.from(nodeList);
        const idx = items.indexOf(document.activeElement);
        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                (_a = items[(idx + 1) % items.length]) === null || _a === void 0 ? void 0 : _a.focus();
                break;
            case 'ArrowUp':
                e.preventDefault();
                (_b = items[(idx - 1 + items.length) % items.length]) === null || _b === void 0 ? void 0 : _b.focus();
                break;
            case 'Home':
                e.preventDefault();
                (_c = items[0]) === null || _c === void 0 ? void 0 : _c.focus();
                break;
            case 'End':
                e.preventDefault();
                (_d = items[items.length - 1]) === null || _d === void 0 ? void 0 : _d.focus();
                break;
            case 'Escape':
                e.preventDefault();
                clickCallback();
                break;
        }
    };
    return (React.createElement(S.Wrapper, { id: `menu-${id}`, role: "menu", tabIndex: -1, "$layout": layout, "$isMobile": isMobile, onKeyDown: handleMenuKeyDown, onBlur: (e) => {
            const next = e.relatedTarget;
            if (!e.currentTarget.contains(next)) {
                clickCallback();
            }
        }, onClick: () => clickCallback() },
        !isEmpty(compact(top)) && React.createElement(SubMenuSection, { items: top, clickCallback: clickCallback }),
        React.createElement("div", null,
            !isEmpty(compact(main)) && React.createElement(SubMenuSection, { items: main, clickCallback: clickCallback }),
            !isEmpty(compact(sidebar)) && (React.createElement(SubMenuSection, { items: sidebar, clickCallback: clickCallback }))),
        !isEmpty(compact(bottom)) && React.createElement(SubMenuSection, { items: bottom, clickCallback: clickCallback })));
};
export default SubMenuContainer;
//# sourceMappingURL=index.js.map